/**
 * 文件上传
 * Created by HeMengJiao on 2020/03/16.
 */
import axios from 'axios';
import AppConfig from '../appConfig';

export default {
  post(url, data, config = {}) {
    // qs.stringify(data)
    return axios({
      method: 'post',
      baseURL: AppConfig.API.UPLOAD_URL,
      url,
      data: data,
      timeout: 10000,
      headers: config.headers ? config.headers
        : {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json; charset=UTF-8'
        }
    })
      .then((response) => {
        return response
      })
      .catch((err) => {
        return err
      })
  }
}



// WEBPACK FOOTER //
// ./src/factory-api/upload-https.js